import React from 'react';
import PropTypes from 'prop-types';
import { Box, Container, Typography } from '@mui/material';
import LazyLoad from 'react-lazyload';
import CustomButton from 'components/CustomButton';
import NextLink from 'next/link';
import { useStyles } from './styles';

const Props = {
  textTitle: PropTypes.node.isRequired,
  textDescription: PropTypes.node.isRequired,
  textButton: PropTypes.string.isRequired,
};

export default function CustomLandingPage({ textTitle, textDescription, textButton }) {
  const classes = useStyles();

  return (
    <LazyLoad offset={100}>
      <Box bgcolor="#EEEEEE" py={10}>
        <Container>
          <Box display="flex" justifyContent="center" alignItems="center">
            <Box mr={6}>
              <Typography variant="h4" component="h2" className={classes.primaryColor}>
                <b>{textTitle}</b>
              </Typography>

              <Box pt={3} pb={4}>
                <Typography className={classes.textDescription} variant="h6" component="p">
                  {textDescription}
                </Typography>
              </Box>

              <NextLink href={`/institutions/book-a-demo`} passHref={true}>
                <CustomButton>{textButton}</CustomButton>
              </NextLink>
            </Box>

            <img
              src="/images/institutions/create-landing-page.gif"
              alt="create landing page gif"
              loading="lazy"
              width={691}
              height={361}
            />
          </Box>
        </Container>
      </Box>
    </LazyLoad>
  );
}

CustomLandingPage.propTypes = Props;
